import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <div className="app">
      <nav className="navbar">
        <Link to="/" className="logo">
          <span className="logo-text">Little Avalon</span>
        </Link>
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/contact">Contact</Link>
          <a href="#download" className="btn-nav">Get the App</a>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Little Avalon</h3>
            <p>Fresh, delicious food delivered to your door or ready for pickup.</p>
          </div>
          <div className="footer-section">
            <h4>Location</h4>
            <p>9410 W Sahara Ave Ste 130<br />Las Vegas, NV 89117</p>
            <p>Phone: (702) 462-9252</p>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Little Avalon. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
